import script from "./_sticker-wrapper.vue?vue&type=script&lang=ts&setup=true"
export * from "./_sticker-wrapper.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__